import { EXPECTED_ERROR_CODES } from "@shared/errors/expected-error-codes";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function readErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  if (isRecord(error) && typeof error.message === "string") {
    return error.message;
  }
  return "";
}

function readErrorCode(error: unknown): string | undefined {
  if (!isRecord(error)) return undefined;

  const data = error.data;
  if (isRecord(data) && typeof data.code === "string") return data.code;

  return undefined;
}

export function readApplicationErrorCodeFromMessage(
  message: string,
): string | undefined {
  const plainMatch = message.match(/"code"\s*:\s*"([^"]+)"/);
  if (plainMatch?.[1]) return plainMatch[1];

  const escapedMatch = message.match(/\\"code\\"\s*:\s*\\"([^"\\]+)\\"/);
  return escapedMatch?.[1];
}

export function isExpectedApplicationErrorCode(
  code: string | undefined,
): boolean {
  return code ? EXPECTED_ERROR_CODES.has(code) : false;
}

export function isExpectedApplicationErrorMessage(message: string): boolean {
  return isExpectedApplicationErrorCode(
    readApplicationErrorCodeFromMessage(message),
  );
}

export function isExpectedApplicationError(error: unknown): boolean {
  return (
    isExpectedApplicationErrorCode(readErrorCode(error)) ||
    isExpectedApplicationErrorMessage(readErrorMessage(error))
  );
}

const EXPECTED_CONTROL_FLOW_MARKER = "__repackifyExpectedControlFlow";

export function markExpectedControlFlowError<TError extends Error>(error: TError): TError {
  Object.defineProperty(error, EXPECTED_CONTROL_FLOW_MARKER, {
    value: true,
    enumerable: false,
  });
  return error;
}

export function isExpectedControlFlowError(error: unknown): boolean {
  return (
    isRecord(error) && error[EXPECTED_CONTROL_FLOW_MARKER] === true
  );
}
